export class ProcessInformationModel {
    responsibles: string[] = [];
    informed: string[] = [];
    organizationsInUse: string[] = [];
    businessDimensions: string[] = [];
}
